module.exports = __webpack_public_path__ + "static/media/PDF_53.33b1ef08.pdf";